module.exports = __webpack_public_path__ + "img/Info_wide.77586300.jpg";